export default __webpack_public_path__ + "static/media/blue_rose.d2fafa11.jpg";